<template>
  <div v-if="!isLoadingPage" class="fluid" id="leadingReportList">
    <div v-if="permission != null">
      <div v-if="permission.read_perm == 1">
        <div class="leadingreport-list-div">
          <v-card elevation="0" class="px-3 py-2" style="width: 100%">
            <v-row>
              <v-col
                cols="12"
                class="d-flex"
                style="
                  position: relative;
                  padding: 0 20px;
                  text-align: center;
                  margin-top: 20px;
                "
              >
                <h4
                  class="indigo--text"
                  style="font-weight: bold; margin: auto"
                >
                  LEADING REPORT
                  <v-tooltip bottom color="grey">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        v-bind="attrs"
                        v-on="on"
                        x-small
                        text
                        icon
                        color="grey darken-2"
                        @click="getDataFromApi"
                      >
                        <v-icon small>mdi-refresh</v-icon>
                      </v-btn>
                    </template>
                    <span>refresh page</span>
                  </v-tooltip>
                </h4>
              </v-col>
              <v-col cols="12">
                <div>
                  <v-toolbar
                    class="group-list-toolbar-1"
                    flat
                    style="
                      height: 60px;
                      border-radius: 10px 10px 0 0;
                      padding-top: 15px;
                    "
                  >
                    <div class="d-flex align-content-start">
                      <div
                        style="margin-right: 15px; height: 45px"
                        class="d-flex justify-center align-center"
                      >
                        <v-btn
                          style="font-size: 12px"
                          @click="addLeadingReport"
                          elevation="2"
                          tilerounded="5px"
                          color="primary"
                          class="white--text"
                          small
                        >
                          <v-tooltip bottom>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon v-bind="attrs" v-on="on" small class="">
                                mdi-plus
                              </v-icon>
                            </template>
                            <span>Tambah Report</span>
                          </v-tooltip>
                        </v-btn>
                      </div>
                    </div>
                    <div style="width: 210px; height: 45px">
                      <v-autocomplete
                        v-model="paramAPI.company_id"
                        label="Perusahaan"
                        item-text="name"
                        item-value="id"
                        return-id
                        dense
                        outlined
                        clearable
                        @change="companyWatcher"
                        :items="dropdown.company"
                        :disabled="isDisableCompanyDropdown"
                      ></v-autocomplete>
                    </div>
                    <div style="width: 180px; height: 45px; margin-left: 15px">
                      <v-autocomplete
                        v-model="paramAPI.status"
                        label="Status"
                        item-text="name"
                        item-value="id"
                        return-id
                        dense
                        outlined
                        clearable
                        @change="statusWatcher"
                        :items="dropdown.status"
                      ></v-autocomplete>
                    </div>
                    <div
                      style="
                        height: 42px;
                        margin-top: 5px;
                        margin-bottom: 8px;
                        margin-left: 10px;
                      "
                      class="d-flex"
                    >
                      <v-menu
                        ref="menu"
                        v-model="menu"
                        :close-on-content-click="false"
                        :return-value.sync="paramAPI.date"
                        transition="scale-transition"
                        offset-y
                        min-width="auto"
                      >
                        <template v-slot:activator="{ on, attrs }">
                          <v-text-field
                            v-model="paramAPI.date"
                            label="Tanggal"
                            append-icon="mdi-calendar"
                            style="height: 30px; font-size: 10px"
                            class="ml-1 mr-2"
                            @click:clear="dateWatcher(null)"
                            outlined
                            clearable
                            readonly
                            dense
                            v-bind="attrs"
                            v-on="on"
                          ></v-text-field>
                        </template>
                        <v-date-picker
                          v-model="paramAPI.date"
                          range
                          no-title
                          scrollable
                        >
                          <v-spacer></v-spacer>
                          <v-btn text color="primary" @click="menu = false">
                            Cancel
                          </v-btn>
                          <v-btn
                            text
                            color="primary"
                            @click="dateWatcher(paramAPI.date)"
                          >
                            OK
                          </v-btn>
                        </v-date-picker>
                      </v-menu>
                    </div>
                    <div
                      style="width: 30%; margin-left: auto; margin-top: 19.5px"
                    >
                      <v-text-field
                        v-model="paramAPI.keyword"
                        @keyup.enter="searchEnter"
                        label="Search here"
                        type="search"
                        append-icon="mdi-magnify"
                        outlined
                        dense
                      ></v-text-field>
                    </div>
                  </v-toolbar>
                </div>
              </v-col>

              <v-col cols="12" style="width: 100%">
                <v-data-table
                  v-if="result.length > 0 || !skeleton_loading"
                  mobile-breakpoint="0"
                  fixed-header
                  height="50vh"
                  :headers="headers"
                  style="cursor: pointer"
                  :items="result"
                  :loading="loading"
                  @click:row="rowClick"
                  item-key="id"
                  :options.sync="options"
                  :footer-props="{
                    showFirstLastPage: true,
                    showCurrentPage: true,
                    itemsPerPageOptions: [1, 3, 5, 10, 15, 100]
                  }"
                  :server-items-length="totalData"
                  :page="paramAPI.page"
                  @update:page="updatePage"
                  :items-per-page="paramAPI.itemsPerPage"
                  @update:items-per-page="updateItemPerPage"
                >
                  <template v-slot:[`item.no`]="{ index }">
                    <div
                      style="
                        font-size: 14px;
                        padding: 0;
                        display: flex;
                        flex-direction: row;
                      "
                    >
                      {{ index + 1 + paramAPI.offset * paramAPI.limit }}
                    </div>
                  </template>
                  <template v-slot:[`item.document_no`]="{ item }">
                    <div
                      style="
                        width: 100px;
                        font-size: 12px;
                        padding: 0;
                        display: flex;
                        flex-direction: row;
                      "
                    >
                      {{ item.document_no }}
                    </div>
                  </template>
                  <template v-slot:[`item.company_name`]="{ item }">
                    <div
                      style="
                        width: 120px;
                        font-size: 12px;
                        padding: 0;
                        display: flex;
                        flex-direction: row;
                      "
                    >
                      {{ item.company_name }}
                    </div>
                  </template>
                  <template v-slot:[`item.leading_date`]="{ item }">
                    <div
                      style="
                        width: 70px;
                        font-size: 12px;
                        padding: 0;
                        display: flex;
                        flex-direction: row;
                      "
                    >
                      {{ item.leading_date }}
                    </div>
                  </template>
                  <template v-slot:[`item.description`]="{ item }">
                    <div
                      style="
                        width: 210px;
                        font-size: 12px;
                        padding: 0;
                        display: flex;
                        flex-direction: row;
                      "
                    >
                      {{ item.leading != null ? item.leading.name : '-' }}
                    </div>
                  </template>
                  <template v-slot:[`item.status`]="{ item }">
                    <div
                      :style="`color: ${itemStatusLeadingColor(item.status)};
                      font-weight: bold;
                      font-size: 12px;
                      padding: 0;
                      display: flex;
                      flex-direction: row;`"
                    >
                      {{ itemStatusLeadingName(item.status) }}
                    </div>
                  </template>
                  <!-- <template v-slot:[`item.createdAt`]="{ item }">
                    <div
                      style="
                        width: 80px;
                        font-size: 12px;
                        padding: 0;
                        display: flex;
                        flex-direction: row;
                      "
                    >
                      {{ convertDate(item.createdAt) }}
                    </div>
                  </template>
                  <template v-slot:[`item.updatedAt`]="{ item }">
                    <div
                      style="
                        width: 80px;
                        font-size: 12px;
                        padding: 0;
                        display: flex;
                        flex-direction: row;
                      "
                    >
                      {{ convertDate(item.updatedAt) }}
                    </div>
                  </template> -->
                  <template v-slot:[`item.action`]="{ item }">
                    <div
                      style="
                        width: 40px;
                        font-size: 12px;
                        padding: 0;
                        display: flex;
                        flex-direction: row;
                        justify-content: space-between;
                      "
                    >
                      <v-tooltip right>
                        <template v-slot:activator="{ on, attrs }">
                          <v-icon
                            v-bind="attrs"
                            v-on="on"
                            small
                            color="error"
                            @click.stop="deleteReport(item)"
                          >
                            mdi-delete
                          </v-icon>
                        </template>
                        <span>Delete</span>
                      </v-tooltip>
                    </div>
                  </template>
                </v-data-table>
                <v-skeleton-loader
                  v-else
                  style="width: 100%"
                  type="table-heading, table-tbody, table-tfoot"
                ></v-skeleton-loader>
              </v-col>
            </v-row>
          </v-card>
        </div>
        <!-- form here -->
        <LeadingReportForm
          @loadPage="getDataFromApi"
          :dropdown="dropdown"
          :updateForm="updateForm"
        />
      </div>
      <v-card
        v-else
        flat
        height="90vh"
        style="display: flex; justify-content: center; align-items: center"
      >
        <v-toolbar-title class="overline">
          You Can't Access This Page</v-toolbar-title
        >
      </v-card>
    </div>
    <v-card
      v-else
      flat
      height="90vh"
      style="display: flex; justify-content: center; align-items: center"
    >
      <v-toolbar-title class="overline">
        You Can't Access This Page</v-toolbar-title
      >
    </v-card>
  </div>
  <div v-else>
    <v-card
      class="mx-auto"
      width="100%"
      style="
        z-index: 3;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 12px;
        position: fixed;
        top: 0;
        height: 100%;
        left: 0;
        right: 0;
        background: rgba(255, 255, 255);
      "
    >
      <v-progress-circular :size="170" :width="10" color="blue" indeterminate
        >Loading...</v-progress-circular
      >
    </v-card>
  </div>
</template>
<script>
import axios from 'axios'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import buildType from '../../../../services/buildType'
const env = process.env.VUE_APP_BUILD_TYPE
export default {
  name: 'dssk3leadingReportList',
  components: {
    LeadingReportForm: () => import('./components/Form.vue')
  },
  data: () => ({
    config: require('../../../../services/config.json')[env],
    dssApi: buildType.apiURL('dss'),
    eSanqua: buildType.apiURL('esanqua'),
    hrsApi: buildType.apiURL('hrs'),
    build: process.env.VUE_APP_BUILD_TYPE,
    isLoadingPage: true,
    permission: null,
    appLevel: null,
    userLevel: null,
    paramAPI: {
      page: 1,
      keyword: '',
      offset: 0,
      limit: 10,
      itemsPerPage: 10,
      sortBy: 'date',
      sortType: 'desc',
      company_id: null,
      status: null,
      date: null
      // department_id: null
    },
    totalData: 0,
    options: {},
    actionValue: 0,
    result: [],
    loading: false,
    isDisableCompanyDropdown: false,
    dropdown: {
      company: [],
      status: ['Draft', 'Submited', 'Cancel'],
      employee: []
    },
    skeleton_loading: true,
    menu: false,
    updateForm: null
  }),

  async mounted() {
    this.appLevel = this.config.application.dss.userLevel
    this.appLevel.administrator =
      this.config.application.all.userLevel.administrator
    // if (this.getShiftSettingPageQuery !== null) {
    //   this.paramAPI = this.getShiftSettingPageQuery
    // }
    await this.getDataMenu()
    // await this.initDropdown()
  },
  computed: {
    ...mapGetters(['getUserProfile', 'getLeadingReportPageQuery']),
    headers() {
      let arrLeadingReportHeader = []

      arrLeadingReportHeader = [
        {
          text: 'Status',
          value: 'status',
          align: 'left',
          sortable: false
        },
        {
          text: 'No',
          value: 'document_no',
          align: 'left',
          sortable: false
        },
        {
          text: 'Perusahaan',
          value: 'company_name',
          align: 'left',
          sortable: false
        },
        {
          text: 'Kegiatan',
          value: 'description',
          align: 'left',
          sortable: false
        },
        {
          text: 'Tgl. Kegiatan',
          value: 'leading_date',
          align: 'left',
          sortable: false
        },
        {
          text: '',
          value: 'action',
          align: 'left',
          sortable: false
        }
      ]
      return arrLeadingReportHeader
    }
  },
  watch: {
    employeeSearch(val) {
      if (val !== '') {
        val && val !== this.employeeSelect && this.querySelections(val)
      } else {
        this.employeeSelect = null
        this.dropdown.employee = []
      }
    }
  },
  methods: {
    ...mapActions(['menu_access', 'getMenuId']),
    ...mapMutations(['setLeadingReportPageQuery']),
    showMsgDialog(pModalType, pStatusMsg, pBtnCancel) {
      return new Promise((resolve) => {
        this.$swal
          .fire({
            position: 'center',
            icon: pModalType,
            html: '<strong style="font-size:18px;">' + pStatusMsg + '</strong>',
            showConfirmButton: true,
            showCancelButton: pBtnCancel,
            cancelButtonText: 'No'
          })
          .then((r) => {
            resolve(r)
          })
      })
    },
    async getDataMenu() {
      this.isLoadingPage = true
      const split = this.$route.path.split('/')
      const routeModule = '/' + split[1] + '/' + split[2] + '/' + split[3]
      console.log('Path>>>>>', routeModule)
      await this.getMenuId({
        keyword: '',
        path: routeModule
      })
        .then((result) => {
          if (result.data.status_code === '00') {
            const menuId = result.data.data[0].id
            this.userLevel = this.getUserProfile.level.find(
              ({ application }) =>
                application.id === this.config.application.dss.applicationId ||
                application.id === this.config.application.all.applicationId
            )
            console.log('userLevel>>>>>', this.userLevel)
            if (this.userLevel !== null) {
              if (
                this.getUserProfile.level.find(
                  ({ id }) => id == this.appLevel.administrator
                ) !== undefined
              ) {
                this.resetPermission({
                  data: {
                    read_perm: 1,
                    create_perm: 1,
                    update_perm: 1,
                    delete_perm: 1
                  }
                })
              } else {
                this.checkMenuAccess([menuId, this.userLevel.id])
              }
            } else {
              this.resetPermission(null)
            }
          } else {
            this.isLoadingPage = false
          }
        })
        .catch((err) => {
          console.log(err)
          this.isLoadingPage = false
        })
    },

    async checkMenuAccess(payload) {
      await this.menu_access(payload)
        .then((result) => {
          console.log('menuAccess>>>>', result)
          this.resetPermission(result)
        })
        .catch((err) => {
          console.log(err)
          this.resetPermission(null)
        })
    },
    resetPermission(val) {
      this.permission = null

      if (val !== null) {
        if (val.data !== null) {
          if (val.data.read_perm === 1) {
            this.permission = val.data
            this.initDataForLayout()
          }
        }
      }
      this.isLoadingPage = false
    },
    initDataForLayout() {
      if (this.userLevel.user_user_level.allowed_company !== null) {
        if (
          this.userLevel.user_user_level.allowed_company.find(
            ({ id }) => id == this.getUserProfile.employee.company.plant_id
          ) !== undefined
        ) {
          this.paramAPI.company_id = Number(
            this.getUserProfile.employee.company.plant_id
          )
        } else {
          this.paramAPI.company_id = Number(
            this.userLevel.user_user_level.allowed_company[0].id
          )
        }
      } else {
        this.paramAPI.company_id = Number(
          this.getUserProfile.employee.company.plant_id
        )
      }
      if (this.getLeadingReportPageQuery != null) {
        this.paramAPI = this.getLeadingReportPageQuery
      }
      setTimeout(async () => {
        await this.getDataFromApi()
        await this.initDropdown()
      }, 200)
    },
    async initDropdown() {
      this.dropdownCompany()
    },
    resetSomeParam() {
      this.paramAPI.limit = this.paramAPI.itemsPerPage
      this.paramAPI.offset = 0
      this.paramAPI.page = 1
    },
    searchEnter() {
      this.resetSomeParam()
      this.getDataFromApi()
    },
    companyWatcher() {
      this.resetSomeParam()
      this.getDataFromApi()
    },
    statusWatcher() {
      this.resetSomeParam()
      this.getDataFromApi()
    },
    dateWatcher(val) {
      if (val == null) {
        this.paramAPI.date = null
      }
      this.$refs.menu.save(val)
      // this.resetSomeParam()
      this.getDataFromApi()
    },
    async dropdownCompany() {
      const level = this.getUserProfile.level.find(
        ({ id }) =>
          id == this.appLevel.administrator || id == this.appLevel.adminK3
      )
      let xFlag = false
      if (level !== undefined) {
        if (level.user_user_level !== null) {
          if (
            level.user_user_level.allowed_company === null ||
            level.user_user_level.allowed_company.length === 0
          ) {
            xFlag = true
          } else {
            this.dropdown.company = level.user_user_level.allowed_company
            this.isDisableCompanyDropdown = false
          }
        } else {
          xFlag = true
        }
      } else {
        xFlag = true
      }

      if (xFlag) {
        if (Number(this.getUserProfile.employee.company.plant_id) !== 6) {
          this.isDisableCompanyDropdown = true
        } else {
          this.isDisableCompanyDropdown = false
        }
        axios
          .get(`${this.eSanqua}master/universal/plant/dropdown`)
          .then((res) => {
            this.dropdown.company = res.data.data
          })
          .catch((err) => {
            console.log(err)
          })
      }
    },
    async getDataFromApi() {
      this.loading = true
      await this.initDataTable()
        .then((data) => {
          if (data.status_code === '00') {
            this.totalData = data.total_record
            return (this.result = data.data)
          }
          return (this.result = [])
        })
        .catch((err) => {
          console.log(err)
          return (this.result = [])
        })
      this.skeleton_loading = false
      this.loading = false
    },
    async initDataTable() {
      this.updateForm = null
      let url = `${this.dssApi}leadingreport/list?keyword=${
        this.paramAPI.keyword
      }&offset=${this.paramAPI.offset * this.paramAPI.limit}&limit=${
        this.paramAPI.limit
      }`
      const filter = []
      if (this.paramAPI.company_id !== null) {
        filter.push(`{"company_id": ${this.paramAPI.company_id}}`)
      }
      if (this.paramAPI.date != null && this.paramAPI.date.length > 0) {
        if (this.paramAPI.date[0] < this.paramAPI.date[1]) {
          url =
            url +
            `&start_date=${this.paramAPI.date[0]}&end_date=${this.paramAPI.date[1]}`
        } else {
          url =
            url +
            `&start_date=${this.paramAPI.date[1]}&end_date=${this.paramAPI.date[0]}`
        }
      }
      url = url + `&filter=[${filter}]`
      this.setLeadingReportPageQuery(this.paramAPI)
      return await new Promise((resolve) => {
        axios
          .get(url)
          .then((res) => {
            console.log(res)
            resolve(res.data)
          })
          .catch((err) => {
            console.log(err)
          })
      })
    },

    rowClick(pItem) {
      console.log('detail>>>', pItem)
      this.updateForm = {
        act: 'update',
        id: pItem.id,
        company: {
          id: Number(pItem.company_id),
          name: pItem.company_name
        },
        leading: pItem.leading,
        leading_date: pItem.leading_date,
        description: pItem.description,
        status: pItem.status,
        file: pItem.file,
        total_participant: pItem.total_participant
      }
      setTimeout(() => {
        document.getElementById('leadingReportForm').click()
      }, 200)
      // setTimeout(() => {
    },
    async deleteReport(pItem) {
      this.showMsgDialog(
        'question',
        'Are you sure, This data will be deleted permanently',
        true
      ).then(async (res) => {
        if (res.isConfirmed) {
          this.loading = true
          await axios
            .delete(`${this.dssApi}leadingreport/delete/${pItem.id}`)
            .then(async (res) => {
              if (res.data.status_code !== '-99') {
                this.showMsgDialog('success', res.data.status_msg, false)
                this.getDataFromApi()
              } else {
                this.showMsgDialog('warning', res.data.status_msg, false)
              }
              this.loading = false
            })
            .catch((err) => {
              this.loading = false
              this.showMsgDialog(
                'error',
                err
                  ? 'Something went wrong, Please contact an admin!'
                  : 'Something went wrong, Please contact an admin!',
                false
              )
            })
        }
      })
    },
    addLeadingReport() {
      setTimeout(() => {
        document.getElementById('leadingReportForm').click()
      }, 200)
    },
    async updatePage(p) {
      this.paramAPI.page = p
      this.paramAPI.offset = p - 1
      await this.getDataFromApi()
    },
    async updateItemPerPage(p) {
      this.paramAPI.itemsPerPage = p
      this.paramAPI.limit = p
      this.paramAPI.offset = 0
      await this.getDataFromApi()
    },
    convertDate(raw) {
      if (raw !== null) {
        const date = new Date(raw)
        const local = date.toLocaleString('id')
        return local
      } else {
        return '-'
      }
    },
    itemStatusLeadingColor(val) {
      if (val) {
        if (val.id == -1) {
          return 'red'
        } else {
          const arrColour = ['black', 'green', 'red']
          return arrColour[val.id]
        }
      }
    },
    itemStatusLeadingName(val) {
      if (val) {
        if (val.id == -1) {
          return '-'
        } else {
          const arrStatus = ['Draft', 'Submited', 'Cancel']
          return arrStatus[val.id]
        }
      }
    }
  }
}
</script>
<style lang="scss">
#leadingReportList {
  position: relative;
  .leadingreport-list-div {
    padding: 15px;
    min-height: 50vh;
    display: flex;
    justify-content: center;
    align-items: center;

    .group-list-toolbar-1 {
      .group-list-toolbar-1 {
        width: 60%;
        display: flex;
        flex-direction: row;
        margin-left: auto;
      }
    }
    .bodypart-list-toolbar2 {
      display: none;
    }
  }
}

@media (max-width: 768px) {
  #leadingReportList {
    .leadingreport-list-div {
      .group-list-toolbar-1 {
        .group-list-toolbar-1 {
          display: none;
        }
      }
      .bodypart-list-toolbar2 {
        display: block;
      }
    }
  }
}
</style>
